import { cn } from 'lib/helpers/utility';

import ViewTabs from './ViewTabs';
import ViewsRow from './ViewsRow';

const HeaderViews = ({ isHosted, titled, views, viewCounts, ...viewTabsProps }) => {
  const viewProps = {
    variant: isHosted ? 'tabs' : 'pills',
    sizedByContainer: isHosted,
    allLabel: titled ? 'All' : undefined
  };

  return (
    <div className={cn(isHosted ? 'flex flex-1 basis-0 self-stretch' : 'contents')}>
      {views ? (
        <ViewsRow titled={titled} tabs={isHosted}>
          {views(viewProps)}
        </ViewsRow>
      ) : (
        <ViewTabs {...viewProps} counts={viewCounts} titled={titled} {...viewTabsProps} />
      )}
    </div>
  );
};

export default HeaderViews;
